var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Text from "../../text/Text";
import Box from "../../box/Box";
export default function CostPerCount(_a) {
    var price = _a.price, totalServings = _a.totalServings, rest = __rest(_a, ["price", "totalServings"]);
    if (!price)
        return null;
    return (React.createElement(Box, __assign({ className: "pricePerServing" }, rest),
        React.createElement(Text, { display: "block", color: "grays.4", fontSize: 0 },
            "$",
            (parseFloat(price) / totalServings).toFixed(2),
            React.createElement("span", { className: "sr-only" }, "Per"),
            React.createElement("span", { "aria-hidden": "true" }, " / "),
            "Serving")));
}
//# sourceMappingURL=CostPerServing.js.map